import { ParseError } from "./parse-error";

export class MissingDataError extends ParseError {}
